import { forwardRef, type ReactNode, type Ref, type HTMLAttributes } from 'react';
import type { BaseProps } from '../../theme/index.js';
import { useBaseAttrs, splitBaseProps } from '../_internal/factory.js';
import './Code.css';

export interface CodeProps extends BaseProps, Omit<HTMLAttributes<HTMLElement>, 'color'> {
  block?: boolean;
  children?: ReactNode;
}

/** Inline `<code>` or block `<pre><code>` element. */
export const Code = forwardRef(function Code(
  { block, children, ...rest }: CodeProps,
  ref: Ref<HTMLElement>
): ReactNode {
  const base = useBaseAttrs('rr-code', rest, [block && 'rr-code--block']);
  const { dom } = splitBaseProps(rest);
  if (block) {
    return (
      <pre {...dom} ref={ref as Ref<HTMLPreElement>} {...base.attrs} className={`${base.className} rr-code--pre`} style={base.style}>
        <code>{children}</code>
      </pre>
    );
  }
  return (
    <code {...dom} ref={ref} {...base.attrs} className={base.className} style={base.style}>
      {children}
    </code>
  );
});
